import createObjectFromAmenityList
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/functions/createObjectFromAmenityList";
import getSingleAndReturnAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/functions/getSingleAndReturnAmenities";
import useGetSelectedCountAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useGetSelectedCountAmenities";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns selected single and return amenities objects (updated only when "updateOnChangeArray" params is changed)
 */
export default function useSelectedAmenities(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType) {
    const {
        singleAmenities,
        returnAmenities,
    } = getSingleAndReturnAmenities(pairedAmenityGroups)

    const {getSelectedCountAmenities} = useGetSelectedCountAmenities()
    const {isReturn} = useAppSelector((state) => (state.checkOrder.ticket))

    const selectedSingleAmenities = createObjectFromAmenityList(getSelectedCountAmenities(singleAmenities, "single"))

    const selectedReturnAmenities = isReturn
        ? createObjectFromAmenityList(getSelectedCountAmenities(returnAmenities, "return"))
        : {}

    return {
        selectedSingleAmenities,
        selectedReturnAmenities,
    }
}